import {QuestionList} from "./QuestionList";
import {QuestionEdit} from "./QuestionEdit";
import {QuestionCreate} from "./QuestionCreate";

export default {
    list: QuestionList,
    create: QuestionCreate,
    edit: QuestionEdit
};
